import React from 'react';
import { Stack, Avatar, Box, ListItem, Typography, alpha, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { } from '@mui/material';
import PropTypes from 'prop-types';
import { Fonts, COLORS, stringAvatar } from 'shared/constants/AppEnums';
import { onGetCountNotifications, onGetNotifications, onReadNotification } from 'redux/actions/Portal';
import { Loop } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';
import AppList from '../AppList';
import { blue, brown, grey, indigo, orange, purple } from '@mui/material/colors';

const Notifikasi = ({ onCloseNotification }) => {
  const dispatch = useDispatch();
  const navigation = useNavigate()

  useEffect(() => {
    dispatch(onGetNotifications());
    dispatch(onGetCountNotifications());
  }, [dispatch]);

  const [notificationData] = useSelector(({ portal }) => [portal.notifications]);
  const [localNotif, setLocalNotif] = useState(notificationData);

  useEffect(() => {
    setLocalNotif(notificationData);
  }, [notificationData])

  const handleNext = () => {
    let p = localNotif.next.split("=")[1];
    dispatch(onGetNotifications(p, true));
  };

  const handleClickNotification = (item) => {
    const data = localNotif?.results
    const index = data.findIndex(x => x.id === item.id && !item.is_read)

    if (index > -1) {
      data[index]['is_read'] = true
      setLocalNotif(prev => ({
        ...prev,
        results: data
      }))
      dispatch(onReadNotification(item.id))
    }
    onCloseNotification()
    if (item?.action === 'COMMENT') {
      navigation(item.full_url + `?comment_id=${item?.extra_id}`)
    } else {
      navigation(item.full_url)
    }
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: {
            xs: 400,
            md: 450
          },
          gap: 4
        }}
      >

        <Stack flex={1} overflow={'hidden'}>
          {
            localNotif.results?.length === 0 ? (
              <Stack alignItems={'center'} justifyContent={'center'} height={'100% !important'}>
                <Typography>Tidak ada notifikasi</Typography>
              </Stack>
            ) : (
              <Stack height={1} overflow={'auto'} id="scrollableDiv">
                <InfiniteScroll
                  dataLength={localNotif?.results.length || 0}
                  hasMore={Boolean(localNotif.next)}
                  next={handleNext}
                  scrollableTarget="scrollableDiv"
                  loader={
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'center'} color={grey[500]} p={2} spacing={1}>
                      <Box sx={{ animation: 'rotate360 2s linear infinite' }}>
                        <Loop />
                      </Box>

                      <Typography>Loading</Typography>
                    </Stack>
                  }
                >
                  <AppList
                    data={localNotif?.results || []}
                    renderRow={(item, i) => (
                      <NotifikasiItem key={item.id} item={item} handleClickNotification={() => handleClickNotification(item)} />
                    )}
                  />
                </InfiniteScroll>
              </Stack>
            )
          }
        </Stack>
      </Box>
    </>

  );
};

export default Notifikasi;

const NotifikasiItem = (props) => {
  const { item, handleClickNotification } = props;

  const renderBackgroundApp = (app) => {
    let bg = ''
    switch (app) {
      case 'Perizinan Menteri':
        bg = alpha(COLORS.primary, 0.8)
        break;
      case 'Dokumen Lain':
        bg = orange[500]
        break;
      case 'Dokumen SK':
        bg = purple[500]
        break;
      case 'Dokumen PK':
        bg = indigo[500]
        break;
      case 'SiapMutu':
        bg = brown[500]
        break;
      case 'BPK Drive':
        bg = blue[500]
        break;
      default:
        break;
    }

    return bg
  }

  return (
    <ListItem
      className='item-hover'
      alignItems='center'
      sx={{
        gap: 4,
        px: 4,
        cursor: 'pointer',
        transition: '0.3s ease-in-out',
        bgcolor: !item.is_read && alpha(COLORS.primary, 0.1),
        '&:hover': {
          bgcolor: (theme) => !item.is_read ? alpha(COLORS.primary, 0.2) : theme.palette.grey[200],
        }
      }}
      onClick={handleClickNotification}
    >
      <Stack>
        <Tooltip placement='bottom' title={item.app}>
          <Avatar {...stringAvatar(item.app)} sx={{ bgcolor: renderBackgroundApp(item.app) }} />
        </Tooltip>
      </Stack>

      <Stack flex={1}>
        <Typography
          sx={{
            fontSize: 15,
            color: (theme) => theme.palette.text.primary,
            fontWeight: Fonts.MEDIUM,
            overflow: 'hidden',
            wordBreak: 'break-word',
            whiteSpace: 'pre-line'
          }}
        >
          {item.subject_notification}
        </Typography>

        <Typography
          sx={{
            fontSize: 13,
            color: (theme) => theme.palette.text.secondary,
            overflow: 'hidden',
            wordBreak: 'break-word',
            whiteSpace: 'pre-line'
          }}
        >
          {item.message}
        </Typography>
      </Stack>

      <Stack>
        <Typography
          sx={{
            fontSize: 12,
            color: (theme) => theme.palette.text.secondary
          }}
        >
          {moment(item.created_at).format('DD/MM/YYYY | HH:mm:ss')}
        </Typography>
        {/* <Typography
          sx={{
            fontSize: 13,
            color: (theme) => theme.palette.text.secondary
          }}
        >
          {moment(item.created_at).format('HH:mm:ss')}
        </Typography> */}
      </Stack>
    </ListItem>
  );
};

NotifikasiItem.propTypes = {
  item: PropTypes.object.isRequired,
  handleClickNotification: PropTypes.func,
};

Notifikasi.propTypes = {
  onCloseNotification: PropTypes.func
};
